import React from 'react'
import { string, object, array } from 'prop-types'

import {
  StyledText,
  StyledBox,
  StyledBackgroundImage,
  FlexDesktopOnly,
  FlexLazyLoad
} from './styles'

import { Flex, Text, Box } from 'pcln-design-system'

const Collection = ({
  smallHeadingText,
  headingText,
  contentTextPt1,
  contentTextPt2,
  contentTextPt3,
  buttons,
  image,
  imageWebP,
  imageSize,
  clickActions
}) => (
  <StyledBox width={1} p={1}>
    <Flex
      flexWrap='wrap'
      mx={-2}
      style={{
        margin: '0 auto',
        maxWidth: '1280px'
      }}
    >
      <Box
        px={1}
        my={5}
        width={[1, 1, 1, 1 / 2]}
        textAlign={['center', 'center', 'center', 'left']}
      >
        <Box>
          <Box mb={3}>
            <Text fontWeight='bold' caps fontSize={0} mb={3} color='text.light'>
              {smallHeadingText}
            </Text>
            <Text mb={3} fontWeight='bold' fontSize={5}>
              {headingText}
            </Text>
            <StyledText color='text.light' mb={2}>
              {contentTextPt1}
              {contentTextPt2}
              {contentTextPt3}
            </StyledText>
          </Box>
          {[buttons]}
        </Box>
      </Box>
      <FlexDesktopOnly
        flexWrap='wrap'
        width={[1, 1, 1, 1 / 2]}
        px={1}
        my={-1}
        style={{
          flexDirection: 'column'
        }}
      >
        <FlexLazyLoad debounce={false} throttle={50}>
          <StyledBackgroundImage
            image={image}
            imageWebP={imageWebP}
            imageSize={imageSize}
            alt={headingText + ' image'}
          />
        </FlexLazyLoad>
      </FlexDesktopOnly>
    </Flex>
  </StyledBox>
)

Collection.displayName = 'Collection'

Collection.propTypes = {
  smallHeadingText: string,
  headingText: string,
  contentTextPt1: string,
  contentTextPt2: string,
  contentTextPt3: string,
  buttons: array,
  image: string,
  imageWebP: string,
  imageSize: string,
  clickActions: object
}

export default Collection
